import { createContext, ReactNode, useContext } from "react";
import useProject from "hooks/useProject";

const ProjectScopeContext = createContext<string | undefined>(undefined);

/** Override the session project for a subtree (e.g. cross-project search hit). */
export function ProjectScope({
  projectId,
  children,
}: {
  projectId: string;
  children: ReactNode;
}) {
  return (
    <ProjectScopeContext.Provider value={projectId}>
      {children}
    </ProjectScopeContext.Provider>
  );
}

/** Nearest ProjectScope, else the session project. */
export default function useProjectId() {
  const scopedProjectId = useContext(ProjectScopeContext);
  const { projectId: sessionProjectId } = useProject();
  return scopedProjectId || sessionProjectId;
}
